import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import axios from "axios";
function EditRiderVehicle(props) {
  var history = useHistory();
  const [RiderVehicleCategory, setRiderVehicleCategory] = useState("");
  const [transportCategory, setTransportCategory] = useState("");
  const [show, setShow] = useState(false);
  const [viewimage, setViewImage] = useState();
  const { id } = props.match.params;
  const [DlFrontBike, setDlFrontBike] = useState(null);
  const [DlBackBike, setDlBackBike] = useState(null);
  const [DlFrontBikeKey, setDlFrontBikeKey] = useState(null);
  const [DlBackBikeKey, setDlBackBikeKey] = useState(null);

  const [autoNumber, setAutoNumber] = useState("");
  const [insuranceAuto, setInsuranceAuto] = useState(null);
  const [DlFrontAuto, setDlFrontAuto] = useState(null);
  const [DlBackAuto, setDlBackAuto] = useState(null);
  const [RCFrontAuto, setRCFrontAuto] = useState(null);
  const [RCBackAuto, setRCBackAuto] = useState(null);
  const [AutoImage, setautoImage] = useState([]);
  const [insuranceAutoKey, setInsuranceAutoKey] = useState(null);
  const [DlFrontAutoKey, setDlFrontAutoKey] = useState(null);
  const [DlBackAutoKey, setDlBackAutoKey] = useState(null);
  const [RCFrontAutoKey, setRCFrontAutoKey] = useState(null);
  const [RCBackAutoKey, setRCBackAutoKey] = useState(null);
  const [AutoImageKey, setautoImageKey] = useState([]);
  const [AutoAge, setAutoAge] = useState("");

  const [CarNumber, setCarNumber] = useState("");
  const [insuranceCar, setInsuranceCar] = useState(null);
  const [DlFrontCar, setDlFrontCar] = useState(null);
  const [DlBackCar, setDlBackCar] = useState(null);
  const [RCFrontCar, setRCFrontCar] = useState(null);
  const [RCBackCar, setRCBackCar] = useState(null);
  const [CarImage, setCarImage] = useState([]);
  const [insuranceCarKey, setInsuranceCarKey] = useState(null);
  const [DlFrontCarKey, setDlFrontCarKey] = useState(null);
  const [DlBackCarKey, setDlBackCarKey] = useState(null);
  const [RCFrontCarKey, setRCFrontCarKey] = useState(null);
  const [RCBackCarKey, setRCBackCarKey] = useState(null);
  const [CarImageKey, setCarImageKey] = useState([]);
  const [CarAge, setCarAge] = useState("");
  const [transportCategoryCar, setTransportCategoryCar] = useState("");

  const [TruckNumber, setTruckNumber] = useState("");
  const [DlFrontTruck, setDlFrontTruck] = useState(null);
  const [insuranceTruck, setInsuranceTruck] = useState(null);
  const [DlBackTruck, setDlBackTruck] = useState(null);
  const [RCFrontTruck, setRCFrontTruck] = useState(null);
  const [RCBackTruck, setRCBackTruck] = useState(null);
  const [TruckImage, setTruckImage] = useState([]);
  const [DlFrontTruckKey, setDlFrontTruckKey] = useState(null);
  const [insuranceTruckKey, setInsuranceTruckKey] = useState(null);
  const [DlBackTruckKey, setDlBackTruckKey] = useState(null);
  const [RCFrontTruckKey, setRCFrontTruckKey] = useState(null);
  const [RCBackTruckKey, setRCBackTruckKey] = useState(null);
  const [TruckImageKey, setTruckImageKey] = useState([]);
  const [TruckAge, setTruckAge] = useState("");
  const [transportCategoryTruck, setTransportCategoryTruck] = useState("");
  useEffect(() => {
   // getRiderData();
  }, []);
  function registerCycle(e) {
    e.preventDefault();
    let data = {
      name: "Cycle",
      category: "two-wheeler",
    };
    axios
      .post(Baseurl.baseurl + `/rider/register-rider-cycle/${id}`, data)
      .then((response) => {
        if (response.data.status) {
          swal("Sent OTP", "Vehicle Added", "success", {
            button: "Done",
            timer: 1000,
          });
        
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  const onChangeImageBike = (e, id) => {
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 3) {
      if (e.target.files[0]) {
        if (id === "front") {
          setDlFrontBikeKey(e.target.files[0]);
        }
        if (id === "back") {
          setDlBackBikeKey(e.target.files[0]);
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setDlFrontBike(reader.result);
          }
          if (id === "back") {
            setDlBackBike(reader.result);
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  const onChangeImageAuto = (e, id) => {
    e.preventDefault();
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 3) {
      if (e.target.files[0]) {
        if (id === "front") {
          setDlFrontAutoKey(e.target.files[0]);
        }
        if (id === "back") {
          setDlBackAutoKey(e.target.files[0]);
        }
        if (id === "rcfront") {
          setRCFrontAutoKey(e.target.files[0]);
        }
        if (id === "rcback") {
          setRCBackAutoKey(e.target.files[0]);
        }
        if (id === "insurance") {
          setInsuranceAutoKey(e.target.files[0]);
        }


        if (id === "auto") {
          if (AutoImageKey.length < 6) {
            setautoImageKey([...AutoImageKey, e.target.files[0]]);
          }
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setDlFrontAuto(reader.result);
          }
          if (id === "back") {
            setDlBackAuto(reader.result);
          }
          if (id === "rcfront") {
            setRCFrontAuto(reader.result);
          }
          if (id === "rcback") {
            setRCBackAuto(reader.result);
          }
          if (id === "insurance") {
            setInsuranceAuto(reader.result);
          }

          if (id === "auto") {
            if (AutoImage.length < 5) {
              setautoImage([...AutoImage, reader.result]);
            } else {
              swal("Oops", "Cannot upload more than 6 images", "error", {
                button: "Done",
              });
            }
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  const onChangeImageCar = (e, id) => {
    e.preventDefault();
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 3) {
      if (e.target.files[0]) {
        if (id === "front") {
          setDlFrontCarKey(e.target.files[0]);
        }
        if (id === "back") {
          setDlBackCarKey(e.target.files[0]);
        }
        if (id === "rcfront") {
          setRCFrontCarKey(e.target.files[0]);
        }
        if (id === "rcback") {
          setRCBackCarKey(e.target.files[0]);
        }
        if (id === "insurance") {
          setInsuranceCarKey(e.target.files[0]);
        }

        if (id === "Car") {
          if (CarImageKey.length < 5) {
            setCarImageKey([...CarImageKey, e.target.files[0]]);
          }
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setDlFrontCar(reader.result);
          }
          if (id === "back") {
            setDlBackCar(reader.result);
          }
          if (id === "rcfront") {
            setRCFrontCar(reader.result);
          }
          if (id === "rcback") {
            setRCBackCar(reader.result);
          }
          if (id === "insurance") {
            setInsuranceCar(reader.result);
          }

          if (id === "Car") {
            if (CarImage.length < 5) {
              setCarImage([...CarImage, reader.result]);
            } else {
              swal("Oops", "Cannot upload more than 5 images", "error", {
                button: "Done",
              });
            }
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  const onChangeImageTruck = (e, id) => {
    e.preventDefault();
    //setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 3) {
      if (e.target.files[0]) {
        if (id === "front") {
          setDlFrontTruckKey(e.target.files[0]);
        }
        if (id === "back") {
          setDlBackTruckKey(e.target.files[0]);
        }
        if (id === "rcfront") {
          setRCFrontTruckKey(e.target.files[0]);
        }
        if (id === "rcback") {
          setRCBackTruckKey(e.target.files[0]);
        }
        if (id === "insurance") {
          setInsuranceTruckKey(e.target.files[0]);
        }

        if (id === "Truck") {
          if (TruckImageKey.length < 5) {
            setTruckImageKey([...TruckImageKey, e.target.files[0]]);
          } else {
            swal("Oops", "Cannot upload more than 5 images", "error", {
              button: "Done",
            });
          }
        }
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "front") {
            setDlFrontTruck(reader.result);
          }
          if (id === "back") {
            setDlBackTruck(reader.result);
          }
          if (id === "rcfront") {
            setRCFrontTruck(reader.result);
          }
          if (id === "rcback") {
            setRCBackTruck(reader.result);
          }
          if (id === "insurance") {
            setInsuranceTruck(reader.result);
          }

          if (id === "Truck") {
            if (TruckImage.length < 5) {
              setTruckImage([...TruckImage, reader.result]);
            } else {
              swal("Oops", "Cannot upload more than 5 images", "error", {
                button: "Done",
              });
            }
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  function registerBike(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", DlFrontBikeKey);
    data.append("image", DlBackBikeKey);
    data.append("ServiceType", transportCategory);
    data.append("name", "Bike");
    data.append("category", "two-wheeler");
    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/rider/rider-vehicle-register/${id}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          swal("Completed", "Vehicle Added", "success", {
            button: "Done",
            timer: 2000,
          });
        
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function registerAuto(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", DlFrontAutoKey);
    data.append("image", DlBackAutoKey);
    data.append("image", RCFrontAutoKey);
    data.append("image", RCBackAutoKey);
    if(insuranceAutoKey){
      data.append("image", insuranceAutoKey);
      data.append("addedInsurance","true");
    }
    else
    {
      data.append("addedInsurance","false");
    }
    AutoImageKey.map((val) => {
      data.append("image", val);
    });
    data.append("ServiceType", "taxi");
    data.append("name", "auto");
    data.append("category", "auto");
    data.append("riderVehicleNumber", autoNumber);
    data.append("vehicleAge", AutoAge);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/rider/rider-vehicle-register/${id}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          swal("Completed", "Vehicle Added", "success", {
            button: "Done",
            timer: 2000,
          });
         
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function registerCar(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", DlFrontCarKey);
    data.append("image", DlBackCarKey);
    data.append("image", RCFrontCarKey);
    data.append("image", RCBackCarKey);
    data.append("image", insuranceCarKey);
    CarImageKey.map((val) => {
      data.append("image", val);
    });
    data.append("ServiceType", "taxi");
    data.append("name", transportCategoryCar);
    data.append("category", "taxi");
    data.append("riderVehicleNumber", CarNumber);
    data.append("vehicleAge", CarAge);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/rider/rider-vehicle-register/${id}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          swal("Completed", "Vehicle Added", "success", {
            button: "Done",
            timer: 2000,
          });
        
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function registerTruck(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", DlFrontTruckKey);
    data.append("image", DlBackTruckKey);
    data.append("image", RCFrontTruckKey);
    data.append("image", RCBackTruckKey);
    data.append("image", insuranceTruckKey);
    TruckImageKey.map((val) => {
      data.append("image", val);
    });
    data.append("ServiceType", "pick-drop");
    data.append("name", transportCategoryTruck);
    data.append("category", "truck");
    data.append("riderVehicleNumber", TruckNumber);
    data.append("vehicleAge", TruckAge);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/rider/rider-vehicle-register/${id}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          swal("Completed", "Vehicle Added", "success", {
            button: "Done",
            timer: 2000,
          });
         
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function viewImage(img) {
    setShow(true);
    setViewImage(img);
  }

  return (
    <div className="row">
        <div className="col-lg-12">
        <Modal
          size="lg"
          show={show}
          onHide={() => {
            setShow(false);
          }}
        >
          <Modal.Body>
            <div>
              <img
                alt=""
                style={{
                  resizeMode: "cover",
                  width: "100%",
                  height: "100%",
                }}
                className="playerProfilePic_home_tile"
                src={viewimage}
              />
            </div>
          </Modal.Body>
        </Modal>
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <h4 className="card-title text-white">Edit Rider Vehicle</h4>
            <button
              className="btn btn-primary"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          </div>

          <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <label className="col-form-label" htmlFor="val-range">
                    Vehicle Category
                    <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-3">
                  <select
                    multiple={false}
                    className="form-control"
                    id="val-skill"
                    name="val-skill"
                    value={RiderVehicleCategory}
                    onChange={(event) => {
                      setRiderVehicleCategory(event.target.value);
                      // if (event.target.value === "two-wheeler") {
                      //   setNameObject(twoWheeler);
                      // } else if (event.target.value === "car") {
                      //   setNameObject(car);
                      // } else if (event.target.value === "truck") {
                      //   setNameObject(truck);
                      // } else if (event.target.value === "3 Wheeler") {
                      //   setNameObject(threeWheeler);
                      // } else {
                      //   setNameObject(auto);
                      // }
                    }}
                  >
                    <option selected={true} disabled="disabled">
                      {RiderVehicleCategory}
                    </option>
                    <option value="Cycle">Cycle</option>
                    <option value="two-wheeler">Bike</option>
                    {/* <option value="3 Wheeler">3 Wheeler</option> */}
                    <option value="auto">Auto</option>
                    <option value="car">Car</option>
                    <option value="truck">Truck</option>
                  </select>
                </div>
                {/* <div className="col-sm-3">
                <label className="col-form-label" htmlFor="val-range">
                  Vehicle Category
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-3">
                <select
                  multiple={false}
                  className="form-control"
                  id="val-skill"
                  name="val-skill"
                  value={RiderVehicleType}
                  onChange={(event) => {
                    setRiderVehicleType(event.target.value);
                  }}
                >
                  <option selected={true} disabled="disabled">
                    {RiderVehicleType}
                  </option>
                  {nameObject &&
                    nameObject.map((val) => <option value={val}>{val}</option>)}
                </select>
              </div> */}
              </div>
              {RiderVehicleCategory === "Cycle" && (
                <form
                  onSubmit={(e) => {
                    registerCycle(e);
                  }}
                >
                  <div className="text-center mt-4">
                    <input
                      className="btn btn-primary"
                      type="submit"
                      value="submit"
                    />
                  </div>
                </form>
              )}
              {RiderVehicleCategory === "two-wheeler" && (
                <form
                  onSubmit={(e) => {
                    registerBike(e);
                  }}
                >
                  <div className="row mt-4">
                    <div className="col-sm-3">
                      <label className="col-form-label" htmlFor="val-range">
                        Transport Category
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <select
                        required
                        multiple={false}
                        className="form-control"
                        id="val-skill"
                        name="val-skill"
                        value={transportCategory}
                        onChange={(event) => {
                          setTransportCategory(event.target.value);
                        }}
                      >
                        <option selected={true} disabled="disabled"></option>
                        <option value="own">White Board Bike Transport</option>
                        <option value="rent">Electric Bike Transport</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mt-4">
                    {transportCategory && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Driving Licence (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageBike(e, "front");
                            }}
                          />

                          {DlFrontBike && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={DlFrontBike}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {DlFrontBike && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Driving Licence (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageBike(e, "back");
                            }}
                          />

                          {DlBackBike && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={DlBackBike}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  {DlBackBike && (
                    <div className="float-right mt-4">
                      <input
                        className="btn btn-primary"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              )}
              {RiderVehicleCategory === "auto" && (
                <form
                  onSubmit={(e) => {
                    registerAuto(e);
                  }}
                >
                  <div className="row mt-4">
                    <div className="mt-2 col-sm-3">
                      <label>Vehicle Number</label>
                    </div>
                    <div className="col-sm-3">
                      <input
                        required
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={autoNumber}
                        onChange={(e) => {
                          setAutoNumber(e.target.value.toUpperCase());
                        }}
                        placeholder="KA XX AB XXXX"
                      />
                    </div>
                    {autoNumber && (
                      <>
                        <div className="mt-2 col-sm-3">
                          <label>Vehicle Age</label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            required
                            type="text"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={AutoAge}
                            onChange={(e) => {
                              setAutoAge(e.target.value);
                            }}
                            placeholder="Enter vehicle age"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                  <div className="col-sm-3">
                    <label>
                      Insurance Image (Optional)
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-3">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangeImageAuto(e, "insurance");
                      }}
                    />

                    {insuranceAuto && (
                      <div
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                        className="col-sm-8"
                      >
                        <img
                          alt=""
                          className="playerProfilePic_home_tile"
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          src={insuranceAuto}
                        />
                      </div>
                    )}
                  </div>
                </div>
                  <div className="row mt-4">
                    {AutoAge && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Driving Licence (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageAuto(e, "front");
                            }}
                          />

                          {DlFrontAuto && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={DlFrontAuto}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {DlFrontAuto && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Driving Licence (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageAuto(e, "back");
                            }}
                          />

                          {DlBackAuto && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={DlBackAuto}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="row mt-4">
                    {DlBackAuto && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Registration Certificate (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageAuto(e, "rcfront");
                            }}
                          />

                          {RCFrontAuto && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={RCFrontAuto}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {RCFrontAuto && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Registration Certificate (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageAuto(e, "rcback");
                            }}
                          />

                          {RCBackAuto && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={RCBackAuto}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {RCBackAuto && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Upload Auto Image (minimum 2 | maximum 6)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageAuto(e, "auto");
                            }}
                          />
                          <div className="row">
                            {AutoImage &&
                              AutoImage.map((val) => {
                                return (
                                  <div
                                    style={{
                                      marginTop: "5px",
                                      width: 180,
                                      height: 100,
                                      aspectRatio: 1 * 1.4,
                                    }}
                                    className="col-sm-3"
                                  >
                                    <img
                                      alt=""
                                      className="playerProfilePic_home_tile"
                                      style={{
                                        resizeMode: "cover",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      src={val}
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {AutoImage.length > 2 && (
                    <div className="float-right mt-4">
                      <input
                        className="btn btn-primary"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              )}
              {RiderVehicleCategory === "car" && (
                <form
                  onSubmit={(e) => {
                    registerCar(e);
                  }}
                >
                  <div className="row mt-4">
                    <div className="col-sm-3">
                      <label className="col-form-label" htmlFor="val-range">
                        Car Body Type
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <select
                        required
                        multiple={false}
                        className="form-control"
                        id="val-skill"
                        name="val-skill"
                        value={transportCategoryCar}
                        onChange={(event) => {
                          setTransportCategoryCar(event.target.value);
                        }}
                      >
                        <option selected={true} disabled="disabled"></option>
                        {/* values shuld addd for backend purpose */}
                        <option value="Hatch Back">Hatch Back</option>
                        <option value="Sedan">Sedan</option>
                        <option value="SUV/MUV">SUV/MUV</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mt-4">
                    {transportCategoryCar && (
                      <>
                        <div className="mt-2 col-sm-3">
                          <label>Vehicle Number</label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            required
                            type="text"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={CarNumber}
                            onChange={(e) => {
                              setCarNumber(e.target.value.toUpperCase());
                            }}
                            placeholder="KA XX AB XXXX"
                          />
                        </div>
                      </>
                    )}
                    {CarNumber && (
                      <>
                        <div className="mt-2 col-sm-3">
                          <label>Vehicle Age</label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            required
                            type="text"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={CarAge}
                            onChange={(e) => {
                              setCarAge(e.target.value);
                            }}
                            placeholder="Enter vehicle age"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {CarAge && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Insurance Image
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "insurance");
                            }}
                          />

                          {insuranceCar && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={insuranceCar}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {insuranceCar && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Driving Licence (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "front");
                            }}
                          />

                          {DlFrontCar && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={DlFrontCar}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {DlFrontCar && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Driving Licence (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "back");
                            }}
                          />

                          {DlBackCar && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={DlBackCar}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="row mt-4">
                    {DlBackCar && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Registration Certificate (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "rcfront");
                            }}
                          />

                          {RCFrontCar && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={RCFrontCar}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {RCFrontCar && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Registration Certificate (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "rcback");
                            }}
                          />

                          {RCBackCar && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={RCBackCar}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {RCBackCar && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Upload Car Image (minimum 2 | maximum 6)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageCar(e, "Car");
                            }}
                          />
                          <div className="row">
                            {CarImage &&
                              CarImage.map((val) => {
                                return (
                                  <div
                                    style={{
                                      marginTop: "5px",
                                      width: 180,
                                      height: 100,
                                      aspectRatio: 1 * 1.4,
                                    }}
                                    className="col-sm-3"
                                  >
                                    <img
                                      alt=""
                                      className="playerProfilePic_home_tile"
                                      style={{
                                        resizeMode: "cover",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      src={val}
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {CarImage.length > 2 && (
                    <div className="float-right mt-4">
                      <input
                        className="btn btn-primary"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              )}
              {RiderVehicleCategory === "truck" && (
                <form
                  onSubmit={(e) => {
                    registerTruck(e);
                  }}
                >
                  <div className="row mt-4">
                    <div className="col-sm-3">
                      <label className="col-form-label" htmlFor="val-range">
                        Truck Type
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <select
                        required
                        multiple={false}
                        className="form-control"
                        id="val-skill"
                        name="val-skill"
                        value={transportCategoryTruck}
                        onChange={(event) => {
                          setTransportCategoryTruck(event.target.value);
                        }}
                      >
                        <option selected={true} disabled="disabled"></option>
                        {/* values shuld addd for backend purpose */}
                        <option value="Tata Ace">Tata Ace</option>
                        <option value="3 Wheeler">3 Wheeler</option>
                        <option value="Pickup 8ft">Pickup 8ft</option>
                      </select>
                    </div>
                  </div>

                  <div className="row mt-4">
                    {transportCategoryTruck && (
                      <>
                        <div className="mt-2 col-sm-3">
                          <label>Vehicle Number</label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            required
                            type="text"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={TruckNumber}
                            onChange={(e) => {
                              setTruckNumber(e.target.value.toUpperCase());
                            }}
                            placeholder="KA XX AB XXXX"
                          />
                        </div>
                      </>
                    )}
                    {TruckNumber && (
                      <>
                        <div className="mt-2 col-sm-3">
                          <label>Vehicle Age</label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            required
                            type="text"
                            className="form-control"
                            id="val-username"
                            name="val-username"
                            value={TruckAge}
                            onChange={(e) => {
                              setTruckAge(e.target.value);
                            }}
                            placeholder="Enter vehicle age"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {TruckAge && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Insurance Image
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "insurance");
                            }}
                          />

                          {insuranceTruck && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={insuranceTruck}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {insuranceTruck && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Driving Licence (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "front");
                            }}
                          />

                          {DlFrontTruck && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={DlFrontTruck}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {DlFrontTruck && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Driving Licence (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "back");
                            }}
                          />

                          {DlBackTruck && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={DlBackTruck}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="row mt-4">
                    {DlBackTruck && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Registration Certificate (front)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "rcfront");
                            }}
                          />

                          {RCFrontTruck && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={RCFrontTruck}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {RCFrontTruck && (
                      <>
                        <div className="col-sm-3">
                          <label className="col-form-label" htmlFor="val-range">
                            Registration Certificate (Back)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-3">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "rcback");
                            }}
                          />

                          {RCBackTruck && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="col-sm-8"
                            >
                              <img
                                alt=""
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                className="playerProfilePic_home_tile"
                                src={RCBackTruck}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row mt-4">
                    {RCBackTruck && (
                      <>
                        <div className="col-sm-3">
                          <label>
                            Upload Truck Image (minimum 2 | maximum 6)
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-sm-9">
                          <input
                            className="col-sm-12"
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangeImageTruck(e, "Truck");
                            }}
                          />
                          <div className="row">
                            {TruckImage &&
                              TruckImage.map((val) => {
                                return (
                                  <div
                                    style={{
                                      marginTop: "5px",
                                      width: 180,
                                      height: 100,
                                      aspectRatio: 1 * 1.4,
                                    }}
                                    className="col-sm-3"
                                  >
                                    <img
                                      alt=""
                                      className="playerProfilePic_home_tile"
                                      style={{
                                        resizeMode: "cover",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      src={val}
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {TruckImage.length > 2 && (
                    <div className="float-right mt-4">
                      <input
                        className="btn btn-primary"
                        type="submit"
                        value="submit"
                      />
                    </div>
                  )}
                </form>
              )}
            </div>
        </div>
      </div>
    </div>
  );
}

export default EditRiderVehicle;
